import {useState, useRef, useEffect}from "react";
import {Routes, Route } from "react-router-dom";
import {useLocation} from 'react-router-dom';
import Layout from "./Layout";
import Home from "./Home";
import Analyzer from "./Analyzer";
import About from "./About";
import Pricing from "./Pricing";
import Login from "./Login";
import Join from "./Join";

export default function App() {

const location = useLocation();  
const [activeCard, setActiveCard] = useState('A');
const cards = Array.from({ length: 20 }, (_, i) => String.fromCharCode(65 + i));

const [cardSelections, setCardSelections] = useState(
  cards.reduce((acc, card) => ({ ...acc, [card]: [] }), {})
);

 const [bets, setBets] = useState(
  cards.reduce((acc, card) => ({ ...acc, [card]: 0 }), {})
);
const [showAllCards, setShowAllCards] = useState(false);
const [drawnNumbers, setDrawnNumbers] = useState([]);
const [hits, setHits] = useState(
  cards.reduce((acc, card) => ({ ...acc, [card]: 0 }), {})
);
const [payouts, setPayouts] = useState(
  cards.reduce((acc, card) => ({ ...acc, [card]: 0 }), {})
);
const [hitFrequencies, setHitFrequencies] = useState(
  cards.reduce((acc, card) => {
    acc[card] = {
      0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0,
      totalWon: 0
    };
    return acc;
  }, {})
);
const [isAutoSession, setIsAutoSession] = useState(false);
const [autoSessionRemaining, setAutoSessionRemaining] = useState(0);
const [autoSessionTotal, setAutoSessionTotal] = useState(0);
const [showContinueButton, setShowContinueButton] = useState(false);
const [sessionGamesPlayed, setSessionGamesPlayed] = useState(0);
const [sessionTotalWon, setSessionTotalWon] = useState(0);
const [sessionTotalWagered, setSessionTotalWagered] = useState(0);
const [credit, setCredit] = useState(() => {
  try {
    const stored = localStorage.getItem('keno-credit');
    return stored ? JSON.parse(stored) : 100;
  } catch {
    return 100;
  }
});
const autoSessionIdRef = useRef(0);

const [denomination, setDenomination] = useState(() => {
  try {
    const stored = localStorage.getItem('keno-denomination');
    return stored ? JSON.parse(stored) : 0.05;
  } catch {
    return 0.05;
  }
});

const [activePaytable, setActivePaytable] = useState(() => {
  try {
    const stored = localStorage.getItem('keno-activePaytable');
    return stored ? JSON.parse(stored) : '838';
  } catch {
    return '838';
  }
});

const [speed, setSpeed] = useState(() => {
  try {
    const stored = localStorage.getItem('keno-speed');
    const val = stored ? JSON.parse(stored) : 'Fast';
    // Migrate old 'Turbo' or unknown values to 'Fast'
    return ['Slow', 'Med', 'Fast'].includes(val) ? val : 'Fast';
  } catch {
    return 'Fast';
  }
});

const [allowBackgroundSessions, setAllowBackgroundSessions] = useState(false);

useEffect(() => {
  if (location.pathname !== '/analyzer') {
    if (!allowBackgroundSessions) {
      // User does NOT want background sessions → pause it
      setIsAutoSession(false);
      autoSessionIdRef.current += 1; // stops the engine loop
    }
    // If allowBackgroundSessions === true → do nothing
  }
}, [location.pathname, allowBackgroundSessions]);

useEffect(() => {
  localStorage.setItem('keno-credit', JSON.stringify(credit));
}, [credit]);

useEffect(() => {
  localStorage.setItem('keno-denomination', JSON.stringify(denomination));
}, [denomination]);

useEffect(() => {
  localStorage.setItem('keno-activePaytable', JSON.stringify(activePaytable));
}, [activePaytable]);

useEffect(() => {
  localStorage.setItem('keno-speed', JSON.stringify(speed));
}, [speed]);

const [savedConfigurations, setSavedConfigurations] = useState(() => {
  try {
    const stored = localStorage.getItem('keno-configurations');
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
});

useEffect(() => {
  localStorage.setItem('keno-configurations', JSON.stringify(savedConfigurations));
}, [savedConfigurations]);


  return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path="analyzer"
            element={
              <Analyzer
                activeCard={activeCard}
                setActiveCard={setActiveCard}
                cardSelections={cardSelections}
                setCardSelections={setCardSelections}
                bets={bets}
                setBets={setBets}
                showAllCards={showAllCards}
                setShowAllCards={setShowAllCards}
                drawnNumbers={drawnNumbers}
                setDrawnNumbers={setDrawnNumbers}
                hits={hits}
                setHits={setHits}
                payouts={payouts}
                setPayouts={setPayouts}
                hitFrequencies={hitFrequencies}
                setHitFrequencies={setHitFrequencies}
                sessionGamesPlayed={sessionGamesPlayed}
                setSessionGamesPlayed={setSessionGamesPlayed}
                sessionTotalWon={sessionTotalWon}
                setSessionTotalWon={setSessionTotalWon}
                sessionTotalWagered={sessionTotalWagered}
                setSessionTotalWagered={setSessionTotalWagered}
                credit={credit}
                setCredit={setCredit}
                denomination={denomination}
                setDenomination={setDenomination}
                activePaytable={activePaytable}
                setActivePaytable={setActivePaytable}
                speed={speed}
                setSpeed={setSpeed}
                savedConfigurations={savedConfigurations}
                setSavedConfigurations={setSavedConfigurations}
                isAutoSession={isAutoSession}
                setIsAutoSession={setIsAutoSession}
                autoSessionRemaining={autoSessionRemaining}
                setAutoSessionRemaining={setAutoSessionRemaining}
                autoSessionTotal={autoSessionTotal}
                setAutoSessionTotal={setAutoSessionTotal}
                showContinueButton={showContinueButton}
                setShowContinueButton={setShowContinueButton}
                  allowBackgroundSessions={allowBackgroundSessions}
                  setAllowBackgroundSessions={setAllowBackgroundSessions}
                  autoSessionIdRef={autoSessionIdRef}
              />
            }
          />
          <Route path="about" element={<About />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="login/*" element={<Login />} />
          <Route path="join/*" element={<Join />} />
        </Route>
      </Routes>
  );
}